/* eslint-disable react/no-unused-state */
import React from 'react'
import withRetailerRouter from 'legacy/common/withRouter'
import {
  WarehousesContext,
  type WarehousesContextValue,
} from 'legacy/contexts/warehouses/WarehousesContext'
import { fetchWarehouses } from 'legacy/common/api'
import { type ScopedRouteParams, AsyncStatus } from 'legacy/common/types'
import { type RetailerRouteComponentProps } from 'legacy/components/RetailerRoute'

interface RouteParams extends ScopedRouteParams {}

interface Props extends RetailerRouteComponentProps<RouteParams> {}

interface State extends WarehousesContextValue {}

class WarehousesProvider extends React.Component<Props, State> {
  readonly state = {
    warehouses: [],
    status: AsyncStatus.Initial,
  }

  fetchPromise?: ReturnType<typeof fetchWarehouses>

  componentDidMount() {
    this.fetchWarehouses()
  }

  componentDidUpdate(lastProps: Props) {
    if (this.props.match.params.partner_id !== lastProps.match.params.partner_id) {
      this.fetchWarehouses()
    }
  }

  componentWillUnmount() {
    this.fetchPromise && this.fetchPromise.cancel()
  }

  async fetchWarehouses() {
    this.setState({
      status: AsyncStatus.Busy,
    })

    try {
      this.fetchPromise = fetchWarehouses(this.props.match.params.partner_id)
      const { data } = await this.fetchPromise

      this.setState({
        status: AsyncStatus.Done,
        warehouses: data,
      })
    } catch (e) {
      this.setState({
        status: AsyncStatus.Fail,
      })
    }
  }

  render() {
    return (
      <WarehousesContext.Provider value={this.state}>
        {this.props.children}
      </WarehousesContext.Provider>
    )
  }
}

export default withRetailerRouter(WarehousesProvider)
